/**
 * This file is used to handle all global animations.
 * 
 * Menu open/close for example.
 */

import { installLegacyCollapseCompatibility } from './bootstrap-collapse-compat';

(function (window, $) {
    const menuName = 'menu-open';

    const classNames = {
        sidebarToggle: 'sidebar-toggle',
        sidebarToggleReverse: 'sidebar-toggle-reverse',
        maincontentMarginClose: 'maincontent-margin-close'
    };

    const elementLocatorNames = {
        mainSidebar: '#main-sidebar',
        mainContentMargin: '.maincontent-margin'
    };

    function setLeftOffsetProperty(isOpen: boolean): void {
        const leftOffset = isOpen
            ? '17rem'
            : '0rem';

        document.documentElement.style
            .setProperty('--left-offset', leftOffset);
    }

    function storeMenuOpen(isOpen: boolean): void {
        localStorage.setItem(menuName, String(isOpen));
    }

    function addReversedState(): void {
        $(elementLocatorNames.mainSidebar).addClass(classNames.sidebarToggleReverse);
        $(elementLocatorNames.mainContentMargin).addClass(classNames.maincontentMarginClose);
    }

    function removeReversedState(): void {
        $(elementLocatorNames.mainSidebar).removeClass(classNames.sidebarToggleReverse);
        $(elementLocatorNames.mainContentMargin).removeClass(classNames.maincontentMarginClose);
    }

    function openMenu() {
        removeReversedState();

        setLeftOffsetProperty(true);
        storeMenuOpen(true);
    }

    function closeMenu(): void {
        addReversedState();

        setLeftOffsetProperty(false);
        storeMenuOpen(false);
    }

    function toggleMenu(): void {
        const currentlyOpen = localStorage.getItem(menuName);
        if (currentlyOpen === 'false') {
            openMenu();
        } else {
            closeMenu();
        }
    }

    function toggleMobileMenu() {
        $(elementLocatorNames.mainSidebar).toggleClass(classNames.sidebarToggle);

        // Ensure standard menu reverse/ close is NOT set - we'll need to remove the reverse sidebar toggle class in order to see the mobile menu transition.
        removeReversedState();
    }

    function closeMobileMenu(): void {
        $(elementLocatorNames.mainSidebar).removeClass(classNames.sidebarToggle);
    }

    function initMenu(): void {
        const currentlyOpen = localStorage.getItem(menuName);
        if (currentlyOpen === 'false') {
            closeMenu();
        }
    }

    $(document).on('click', '#h-menu', function () {
        toggleMenu();
    });

    $(document).on('click', '#sidebar-toggle', function () {
        toggleMobileMenu();
    });

    $(document).on('click', '.maincontent-margin', function () {
        // Mobile menu, main click should auto close sidebar.
        closeMobileMenu();
    });

    $(window).resize(function () {
        const viewportWidth = $(window).width();

        // On resize respect the css media query --left-offset: 0 setting, programmatically set here accordingly.
        if (viewportWidth && viewportWidth <= 991) {
            setLeftOffsetProperty(false);

            // Ensure standard menu reverse/ close is NOT set - we'll need to remove the reverse sidebar toggle class in order to see the mobile menu transition.
            removeReversedState();
        } else {
            // Set standard menu state based from storage.
            const currentlyOpen = localStorage.getItem(menuName);
            if (currentlyOpen === 'false') {
                closeMenu();
            } else {
                openMenu();
            }
        }

        // Always close mobile menu on resize.
        closeMobileMenu();
    });

    // Auto init the menu.
    initMenu();
    installLegacyCollapseCompatibility(window);

})(window, $);
